<template>
  <v-card scrollable>
    <v-row class="pa-5 ma-0">
      <v-col class="py-0">
        <v-form v-model="valid" ref="brand-form">
          <v-row>
            <v-col class="pt-0">
              <v-text-field v-model="brandForm.name" name="name" persistent-hint :label="$t('brand_name')" :hint="$t('brand_name_hint')" @focus="clearErrors('name')" :rules="rules.required" :error-messages="errorMessages.name" required></v-text-field>
            </v-col>
            <v-col class="pt-0">
              <v-text-field v-model="brandForm.reference" name="reference" persistent-hint :label="$t('brand_reference')" :hint="$t('brand_reference_hint')" @focus="clearErrors('reference')" :rules="rules.required" :error-messages="errorMessages.reference" required></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-card-actions class="action-buttons">
      <div v-if="brandForm.id" class="mr-2 d-flex flex-column align-start">
        <v-alert class="delete-warning" icon="mdi-alert-circle-outline" type="error" dense text>
          <span v-if="showDeleteBlockedMessage">{{$t('brand_delete_blocked')}}</span>
          <span v-else-if="errorMessages.delete.length">{{errorMessages.delete[0]}}</span>
        </v-alert>
        <v-btn @click="handleDelete()" :loading="isBrandProductsInfoLoading || isDeletingBrand" color="error" text>
          <v-icon left>mdi-delete</v-icon>
          <span class="delete-btn">{{$t('brand_delete')}}</span>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn text @click="handleClose()">{{$t('close')}}</v-btn>
      <v-btn text color="primary" @click="handleSave()" :loading="savingBrand" >{{$t('save')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>

import amplitude from 'amplitude-js'

export default {
  name: 'BrandForm',
  props: ['brand', 'brandId', 'brandProductsCount', 'brandProductsLoading'],
  data () {
    return {
      valid: false,
      savingBrand: false,
      isDeletingBrand: false,
      showDeleteBlockedMessage: false,
      errorMessages: {
        name: [],
        reference: [],
        delete: []
      },
      brandForm: {
        name: '',
        reference: ''
      },
      rules: {
        required: [
          v => !!v || this.$t('field_required')
        ]
      }
    }
  },
  computed: {
    isBrandProductsInfoLoading () {
      const brandProductsCountLoading = this.brandProductsCount === null || this.brandProductsCount === undefined
      return this.brandProductsLoading || brandProductsCountLoading
    }
  },
  watch: {
    brand (newVal) {
      if (newVal && newVal.reference !== this.brandForm.reference) {
        this.brandForm = {
          ...newVal
        }
      }
    },

    brandId (newVal) {
      if (!newVal) {
        this.brandForm = {
          name: '',
          reference: ''
        }
      }
    }
  },
  methods: {
    clearErrors (key) {
      if (key) {
        this.errorMessages[key] = []
      } else {
        this.errorMessages = {
          name: [],
          reference: [],
          delete: []
        }
      }
    },

    handleClose () {
      this.$refs['brand-form'].reset()
      this.savingBrand = false
      this.isDeletingBrand = false
      this.showDeleteBlockedMessage = false
      this.errorMessages.delete = []
      this.$emit('on-close-dialog')
    },

    async handleSave () {
      this.$refs['brand-form'].validate()
      if (!this.valid) {
        return
      }
      this.savingBrand = true
      if (this.brandForm.id) {
        try {
          await this.$store.dispatch('updateBrand', { brand: this.brandForm })
          this.handleClose()
        } catch (err) {
          for (const key in err.data) {
            this.errorMessages[key] = err.data[key]
          }
          this.savingBrand = false
        }
      } else {
        try {
          const res = await this.$store.dispatch('createBrand', { brand: this.brandForm })
          amplitude.getInstance().logEvent('Create Brand')
          this.$emit('on-brand-created', res)
          this.handleClose()
        } catch (err) {
          for (const key in err.data) {
            this.errorMessages[key] = err.data[key]
          }
          this.savingBrand = false
        }
      }
    },

    async handleDelete () {
      this.errorMessages.delete = []
      if ((this.brandProductsCount || 0) > 0) {
        this.showDeleteBlockedMessage = true
        return
      }

      this.showDeleteBlockedMessage = false
      this.isDeletingBrand = true
      try {
        await this.$store.dispatch('deleteBrand', { brand: this.brandForm })
        this.$emit('on-brand-deleted')
        this.handleClose()
      } catch (err) {
        this.errorMessages.delete = [this.$t('brand_delete_failed')]
        this.isDeletingBrand = false
      }
    }
  },
  created () {
    if (this.brand && this.brand.id) {
      this.brandForm = {
        ...this.brand
      }
    }
  }
}

</script>

<style lang="sass" scoped>

.hint
  font-size: 10px
  text-align: center
  margin-right: 20px

.action-buttons
  align-items: flex-end

.delete-btn
  padding-top: 2px

.delete-warning
  margin: 0 0 4px 0
  padding: 4px 8px
  max-width: 320px
  line-height: 1.3
  font-size: 12px
  border-radius: 6px
  min-height: 40px
  visibility: hidden

  &.v-alert
    align-items: flex-start

  :deep(.v-alert__content)
    display: block

  :deep(.v-icon)
    margin-top: 1px

.delete-warning:has(span)
  visibility: visible
</style>
